import React, { useState, useEffect, useCallback } from 'react';
import { SONGS, GENRES } from './Songsdata';

// ── Inject styles once ────────────────────────────────────────────
const VA_STYLES = `
  .va-backdrop {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.75);
    backdrop-filter: blur(4px);
    z-index: 1000;
    display: flex; align-items: center; justify-content: center;
    padding: 16px;
    animation: va-fade-in 0.2s ease;
  }
  @keyframes va-fade-in { from { opacity:0 } to { opacity:1 } }

  .va-modal {
    background: #0f0f13;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    width: 100%; max-width: 960px; max-height: 88vh;
    display: flex; flex-direction: column;
    overflow: hidden;
    animation: va-slide-up 0.25s cubic-bezier(0.16,1,0.3,1);
    box-shadow: 0 32px 80px rgba(0,0,0,0.6);
  }
  @keyframes va-slide-up {
    from { transform: translateY(24px); opacity:0 }
    to   { transform: translateY(0);    opacity:1 }
  }

  .va-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 18px 24px 14px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .va-header-left { display: flex; align-items: center; gap: 10px; }
  .va-header-icon { font-size: 20px; }
  .va-modal-header h2 { font-size: 16px; font-weight: 600; color: #fff; margin: 0; }
  .va-header-count {
    font-size: 11px; font-weight: 500; color: rgba(255,255,255,0.4);
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
    border-radius: 20px; padding: 3px 10px;
  }
  .va-close-btn {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
    border-radius: 50%; width: 32px; height: 32px;
    color: rgba(255,255,255,0.6); font-size: 18px; line-height: 1;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    transition: background 0.15s, color 0.15s;
  }
  .va-close-btn:hover { background: rgba(255,255,255,0.12); color: #fff; }

  .va-genre-bar {
    display: flex; align-items: center; gap: 6px;
    padding: 10px 24px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    overflow-x: auto; scrollbar-width: none; flex-shrink: 0;
  }
  .va-genre-bar::-webkit-scrollbar { display: none; }
  .va-genre-pill {
    background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
    border-radius: 20px; padding: 5px 14px; font-size: 12px; font-weight: 500;
    color: rgba(255,255,255,0.5); white-space: nowrap; cursor: pointer;
    transition: all 0.15s;
  }
  .va-genre-pill:hover { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.85); }
  .va-genre-pill.active {
    background: color-mix(in srgb, var(--pill-color, #fff) 15%, transparent);
    border-color: color-mix(in srgb, var(--pill-color, #fff) 40%, transparent);
    color: var(--pill-color, #fff);
  }

  .va-search-bar {
    display: flex; align-items: center; gap: 8px;
    padding: 8px 16px; margin: 10px 24px;
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px; flex-shrink: 0;
  }
  .va-search-icon { font-size: 13px; opacity: 0.4; }
  .va-search-input {
    flex: 1; background: none; border: none; outline: none;
    font-size: 13px; color: rgba(255,255,255,0.85); font-family: inherit;
  }
  .va-search-input::placeholder { color: rgba(255,255,255,0.25); }
  .va-search-clear {
    background: none; border: none; color: rgba(255,255,255,0.35);
    font-size: 16px; cursor: pointer; line-height: 1; padding: 0 2px;
  }
  .va-search-clear:hover { color: rgba(255,255,255,0.7); }

  .va-body { display: flex; flex: 1; min-height: 0; overflow: hidden; }

  .va-list {
    width: 46%; overflow-y: auto;
    border-right: 1px solid rgba(255,255,255,0.07);
    scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.1) transparent;
  }
  .va-list::-webkit-scrollbar { width: 4px; }
  .va-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }
  .va-list-empty {
    display: flex; align-items: center; justify-content: center;
    height: 120px; color: rgba(255,255,255,0.3); font-size: 13px;
  }

  .va-track-row {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 16px; cursor: pointer;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    transition: background 0.12s;
  }
  .va-track-row:last-child { border-bottom: none; }
  .va-track-row:hover  { background: rgba(255,255,255,0.04); }
  .va-track-row.active { background: rgba(255,255,255,0.06); }

  .va-row-num {
    font-size: 11px; color: rgba(255,255,255,0.25);
    width: 18px; text-align: center; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
  }
  .va-playing-dot {
    width: 7px; height: 7px; border-radius: 50%; background: #4ade80;
    display: inline-block; animation: va-pulse 1.1s ease-in-out infinite;
  }
  @keyframes va-pulse {
    0%,100% { opacity:1; transform:scale(1) }
    50%     { opacity:0.4; transform:scale(0.75) }
  }

  .va-row-thumb {
    width: 42px; height: 42px; border-radius: 6px; overflow: hidden;
    flex-shrink: 0; position: relative; background: #1a1a22;
  }
  .va-row-thumb img { width: 100%; height: 100%; object-fit: cover; }
  .va-row-thumb-overlay {
    position: absolute; inset: 0; background: rgba(0,0,0,0.5);
    display: flex; align-items: center; justify-content: center;
    opacity: 0; transition: opacity 0.15s;
  }
  .va-track-row:hover .va-row-thumb-overlay,
  .va-track-row.active .va-row-thumb-overlay { opacity: 1; }
  .va-row-play-icon { font-size: 12px; color: #fff; }

  .va-row-meta { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
  .va-row-title {
    font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.85);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .va-track-row.active .va-row-title { color: #fff; }
  .va-row-sub {
    font-size: 11px; color: rgba(255,255,255,0.35);
    display: flex; align-items: center; gap: 6px;
  }
  .va-row-badge {
    font-size: 10px; padding: 2px 7px; border-radius: 10px;
    background: color-mix(in srgb, var(--badge-color,#888) 12%, transparent);
    border: 1px solid color-mix(in srgb, var(--badge-color,#888) 30%, transparent);
    color: var(--badge-color, #888);
  }

  .va-player-col {
    flex: 1; display: flex; flex-direction: column; overflow-y: auto;
    scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.1) transparent;
  }
  .va-player-empty {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 10px; color: rgba(255,255,255,0.2); padding: 40px;
  }
  .va-player-empty-icon { font-size: 40px; opacity: 0.3; }
  .va-player-empty p { font-size: 13px; }

  .va-player-panel { display: flex; flex-direction: column; gap: 14px; padding: 16px 20px; }
  .va-yt-frame {
    position: relative; padding-top: 56.25%;
    border-radius: 12px; overflow: hidden; background: #000; flex-shrink: 0;
  }
  .va-yt-frame iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: none; }

  .va-player-info { display: flex; flex-direction: column; gap: 4px; }
  .va-player-genre-badge {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 11px; font-weight: 600; padding: 3px 10px;
    border-radius: 20px; width: fit-content;
  }
  .va-player-title  { font-size: 16px; font-weight: 700; color: #fff; line-height: 1.3; margin: 4px 0 0; }
  .va-player-artist { font-size: 12px; color: rgba(255,255,255,0.45); }
  .va-player-desc   { font-size: 12px; color: rgba(255,255,255,0.3); margin-top: 2px; line-height: 1.5; }

  .va-player-controls { display: flex; gap: 8px; }
  .va-ctrl-btn {
    flex: 1; background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px; padding: 9px 14px; font-size: 12px; font-weight: 500;
    color: rgba(255,255,255,0.6); cursor: pointer; transition: all 0.15s; font-family: inherit;
  }
  .va-ctrl-btn:hover { background: rgba(255,255,255,0.12); color: #fff; }
  .va-ctrl-btn.primary {
    background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.15);
    color: rgba(255,255,255,0.85);
  }
  .va-ctrl-btn.primary:hover { background: rgba(255,255,255,0.18); color: #fff; }

  .va-modal-footer {
    display: flex; align-items: center; justify-content: space-between;
    padding: 12px 24px;
    border-top: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
  }
  .va-footer-label { font-size: 12px; color: rgba(255,255,255,0.3); }
  .va-footer-nav { display: flex; gap: 6px; }
  .va-nav-btn {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px; width: 32px; height: 32px;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; color: rgba(255,255,255,0.5); cursor: pointer; transition: all 0.15s;
  }
  .va-nav-btn:hover { background: rgba(255,255,255,0.12); color: #fff; }

  @media (max-width: 640px) {
    .va-body { flex-direction: column; }
    .va-list { width: 100%; border-right: none; border-bottom: 1px solid rgba(255,255,255,0.07); max-height: 220px; }
  }
`;

// Inject styles into <head> once
if (typeof document !== 'undefined' && !document.getElementById('va-modal-styles')) {
  const tag = document.createElement('style');
  tag.id = 'va-modal-styles';
  tag.textContent = VA_STYLES;
  document.head.appendChild(tag);
}

// ── Genre label helper ────────────────────────────────────────────
const getGenreMeta = (genreId) =>
  GENRES.find((g) => g.id === genreId) || { label: genreId, icon: '🎵', color: '#888' };

// ── Individual track row ──────────────────────────────────────────
const TrackRow = ({ song, index, isActive, onSelect }) => {
  const genre = getGenreMeta(song.genre);
  return (
    <div
      className={`va-track-row ${isActive ? 'active' : ''}`}
      onClick={() => onSelect(song)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(song)}
      aria-label={`Play ${song.title}`}
    >
      <span className="va-row-num">
        {isActive ? <span className="va-playing-dot" /> : index + 1}
      </span>

      <div className="va-row-thumb">
        <img
          src={`https://img.youtube.com/vi/${song.youtubeId}/mqdefault.jpg`}
          alt={song.title}
          loading="lazy"
        />
        <div className="va-row-thumb-overlay">
          <span className="va-row-play-icon">▶</span>
        </div>
      </div>

      <div className="va-row-meta">
        <span className="va-row-title">{song.title}</span>
        <span className="va-row-sub">
          {song.artist}
          <span className="va-row-badge" style={{ '--badge-color': genre.color }}>
            {genre.icon} {genre.label}
          </span>
        </span>
      </div>
    </div>
  );
};

// ── Player panel ──────────────────────────────────────────────────
const PlayerPanel = ({ song, onNext, onPrev }) => {
  const genre = song ? getGenreMeta(song.genre) : null;

  if (!song) {
    return (
      <div className="va-player-empty">
        <div className="va-player-empty-icon">♫</div>
        <p>Select a song to start playing</p>
      </div>
    );
  }

  return (
    <div className="va-player-panel">
      <div className="va-yt-frame">
        <iframe
          key={song.youtubeId}
          src={`https://www.youtube.com/embed/${song.youtubeId}?autoplay=1&rel=0&modestbranding=1`}
          title={song.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="va-player-info">
        <span
          className="va-player-genre-badge"
          style={{
            background: genre?.color + '22',
            color: genre?.color,
            border: `1px solid ${genre?.color}44`,
          }}
        >
          {genre?.icon} {genre?.label}
        </span>
        <h3 className="va-player-title">{song.title}</h3>
        <p className="va-player-artist">{song.artist}</p>
        {song.description && <p className="va-player-desc">{song.description}</p>}
      </div>

      <div className="va-player-controls">
        <button className="va-ctrl-btn" onClick={onPrev} aria-label="Previous track">
          ⏮ Prev
        </button>
        <button className="va-ctrl-btn primary" onClick={onNext} aria-label="Next track">
          Next ⏭
        </button>
      </div>
    </div>
  );
};

// ── Main Modal ────────────────────────────────────────────────────
const ViewAllModal = ({ isOpen, onClose, initialTrackId, onSelectTrack }) => {
  const [genreFilter, setGenreFilter] = useState('all');
  const [search, setSearch]           = useState('');
  const [activeId, setActiveId]       = useState(initialTrackId || null);

  // Sync active track when modal opens
  useEffect(() => {
    if (isOpen) setActiveId(initialTrackId || null);
  }, [isOpen, initialTrackId]);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Escape closes
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  const visible = SONGS.filter((s) => {
    const gMatch = genreFilter === 'all' || s.genre === genreFilter;
    const q = search.toLowerCase();
    const qMatch =
      !q ||
      s.title.toLowerCase().includes(q) ||
      (s.artist && s.artist.toLowerCase().includes(q)) ||
      s.genre.toLowerCase().includes(q);
    return gMatch && qMatch;
  });

  const activeSong = SONGS.find((s) => s.id === activeId) || null;

  const handleSelect = useCallback(
    (song) => {
      setActiveId(song.id);
      onSelectTrack && onSelectTrack(song);
    },
    [onSelectTrack]
  );

  const navTrack = useCallback(
    (dir) => {
      if (!visible.length) return;
      const idx = visible.findIndex((s) => s.id === activeId);
      const next =
        idx === -1
          ? visible[0]
          : visible[(idx + dir + visible.length) % visible.length];
      if (next) handleSelect(next);
    },
    [visible, activeId, handleSelect]
  );

  if (!isOpen) return null;

  return (
    <div
      className="va-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="All Songs Player"
    >
      <div className="va-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="va-modal-header">
          <div className="va-header-left">
            <span className="va-header-icon">♬</span>
            <h2>All Songs</h2>
            <span className="va-header-count">{SONGS.length} tracks</span>
          </div>
          <button className="va-close-btn" onClick={onClose} aria-label="Close modal">×</button>
        </div>

        {/* Genre filter pills */}
        <div className="va-genre-bar">
          <button
            className={`va-genre-pill ${genreFilter === 'all' ? 'active' : ''}`}
            onClick={() => setGenreFilter('all')}
          >
            All
          </button>
          {GENRES.map((g) => (
            <button
              key={g.id}
              className={`va-genre-pill ${genreFilter === g.id ? 'active' : ''}`}
              style={{ '--pill-color': g.color }}
              onClick={() => setGenreFilter(g.id)}
            >
              {g.icon} {g.label}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="va-search-bar">
          <span className="va-search-icon">🔍</span>
          <input
            type="text"
            className="va-search-input"
            placeholder="Search songs or artists…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <button className="va-search-clear" onClick={() => setSearch('')}>×</button>
          )}
        </div>

        {/* Body */}
        <div className="va-body">
          <div className="va-list">
            {visible.length === 0 ? (
              <div className="va-list-empty"><p>No songs match your search.</p></div>
            ) : (
              visible.map((song, i) => (
                <TrackRow
                  key={song.id}
                  song={song}
                  index={i}
                  isActive={song.id === activeId}
                  onSelect={handleSelect}
                />
              ))
            )}
          </div>

          <div className="va-player-col">
            <PlayerPanel
              song={activeSong}
              onNext={() => navTrack(1)}
              onPrev={() => navTrack(-1)}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="va-modal-footer">
          <span className="va-footer-label">
            {visible.length === SONGS.length
              ? `Showing all ${SONGS.length} tracks`
              : `${visible.length} of ${SONGS.length} tracks`}
          </span>
          <div className="va-footer-nav">
            <button className="va-nav-btn" onClick={() => navTrack(-1)} aria-label="Previous">⏮</button>
            <button className="va-nav-btn" onClick={() => navTrack(1)}  aria-label="Next">⏭</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllModal;
